

<div class="container my-5">

  <!-- Section -->
  <section>
    
    <style>
      .md-pills .nav-link.active {
        color: #fff;
        background-color:#2bae66ff;
      }
      button.close {
        position: absolute;
        right: 0;
        z-index: 2;
        padding-right: 1rem;
        padding-top: .6rem;
      }
      h1,h2{
        
        color: #2bae66ff;
      }
      .thumbnail{
        margin: 5px;
        padding: 5px;
        text-align: center;
      }
      
    </style>
    
    <!-- Modal -->
		

    <!-- <h6 class="font-weight-bold text-center grey-text text-uppercase small mb-4">portfolio</h6> -->
    <!-- <h1 class="font-weight-bold text-center text-success dark-grey-text pb-2">Health</h1>
     -->
<!--First row-->
    <div class="row">

      <!--First column-->
      <div class="col-12 flex-center">

        <!-- Nav tabs -->
        <ul class="nav bg-secondary md-pills flex-center flex-wrap mx-0" role="tablist">
          <li class="nav-item">
            <a class="nav-link active font-weight-bold text-uppercase text-white" data-toggle="tab" href="#panel31" role="tab">Gaon Kalyan Samiti</a>
          </li>
          <li class="nav-item">
            <a class="nav-link font-weight-bold text-uppercase text-white" data-toggle="tab" href="#panel32" role="tab">ANM Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link font-weight-bold text-uppercase text-white" data-toggle="tab" href="#panel33" role="tab">livestock hospital</a>
          </li>
        </ul>

      </div>
      <!--First column-->

    </div>
    <!--First row-->









      <hr class="w-header my-4 bg-sucess">
    
    <!--Tab panels-->
    <div class="tab-content mb-5">


        
      <!--Panel 1-->
      <div class="tab-pane fade show in active" id="panel31" role="tabpanel">

        <div class="container my-5"> 
          <h1>Gaon Kalyan Samiti (GKS) </h1>
            <p>Village Health and Sanitation Committee (VHSC) popularly known as Gaon Kalyan
              Samiti (GKS) in the state of Orissa is a revenue village level institution constituted
              by the community as a simple and effective management structure for
              improvement of health and sanitation standard of the villages as a part of National
              Rural Health Mission initiative. Gaon Kalyan Samiti plays an important role to
              identify local health issues and taking suitable measures to solve the issues. It also
              acts as a facilitating body for implementation of various village level welfare and
              developmental programmes being implemented by Government</p>
              <h2>Members of the GKS </h2>
                <ul><li>The women ward member of the village (If there is no representation of
                        women candidate, the ward member belonging to SC/ST or OBC category on a
                        priority basis. If more than one member of a particular category is existing,
                        then the ward member representing to the larger ward) – President. 
                        </li>
                      <li>Anganwadi Worker of the revenue village (In case of more than one, the
                        senior most Anganwadi Worker under the revenue village)-Convener. 
                        </li>
                        <li>
                          ASHA/s of the village/s. 
                        </li>
                        <li>SEM (Self Employed Mechanics) of the area under Rural Water Supply and
                          Sanitation (RWSS). </li>
                          <li>President or Secretary of up to three women SHGs of the village having
                            highest own saving (preferably SC/ST). </li>
                            <li>President of the Pani Panchayat (Watershed Development Committee)
                              wherever it is formed and if he is residing in the village. </li>
                              <li>Representative of a good functioning Yuvak Sangha or any Community Based
                                Organisation (CBO). </li>
                                <li>If none of the members of the committee belongs to SC/ST, then one member
                                  from each category will be nominated by the president. </li>
                                  While forming the committee care should be taken to ensure that all village or hamlets
                    under the revenue village is represented in the committee properly. 

                      
                      
                </ul>






        <!-- Grid row -->
        <div class="row m-6">
          <!-- <div class="col-md-12 col-lg-4"></div>
          <div class="col-md-6 col-lg-4"></div>
          <div class="col-md-6 col-lg-4"></div> -->
          
            <div class="col-md-4">
              <div class="card thumbnail">
                <a><i class="h1 fa fa-user-circle-o" aria-hidden="true"></i><h2>women ward member</h2>
          
                  <div class="caption">
                <h3>nimalaya sahu(7537900012)</h3><h3>monalisha sahu(7537900013)</h3>
                  </div>
                </a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card thumbnail">
                <a><i class="h1 fa fa-user-circle-o" aria-hidden="true"></i>
          
                  <div class="caption">
                    <h2>Anganwadi Worker</h2>
                    <h3>nimalaya sahu(7537900012)</h3><h3>monalisha sahu(7537900013)</h3>
                  </div>
                </a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card thumbnail">
                <a>
          
                  <div class="caption"><i class="h1 fa fa-user-circle-o" aria-hidden="true"></i>
                   <h2>ASHA/s</h2>
                   <h3>nimalaya sahu(7537900012)</h3><h3>monalisha sahu(7537900013)</h3>
                    </div>
                </a>
              </div>
            </div>
          
        </div>
        <!-- Grid row -->
     </div>
      </div>
      <!--Panel 1-->





      <!--Panel 2-->
      <div class="tab-pane fade" id="panel32" role="tabpanel">

        <!-- Grid row -->
        <div class="row">
          <div class="col-lg-6 mb-4">
            <h2 class="font-weight-normal font-weight-bold mb-4 text-success">Health </h2>
            <!-- <p class="lead text-muted">Beautifully designed by best interior designers for the best web designers</p> -->
            <p class="font-weight-normal text-align-justify ">According to Census 2011 information the location code or village code of Ranipokhari village is 391257. Ranipokhari village is located in Sharata Tehsil of Mayurbhanj district in Odisha, India. It is situated 29km away from sub-district headquarter Sharata and 84km away from district headquarter Baripada. As per 2009 stats, Ranipokhari village is also a gram panchayat.
  
              The total geographical area of village is 957 hectares. Ranipokhari has a total population of 1,810 peoples. There are about 365 houses in Ranipokhari village. As per 2019 stats, Ranipokhari villages comes under Karanjia assembly & Keonjhar parliamentary constituency. Udala is nearest town to Ranipokhari which is approximately 38km away.</p>
          </div>
    
          <div class="col-lg-6 mb-4">
    
            <div class="card text-center">
              <div class="card-header">
                Featured
              </div>
              <div class="card-body">
                <h5 class="card-title">Special title treatment</h5>
                <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                <a href="#" class="btn btn-primary">Go somewhere</a>
              </div>
              <div class="card-footer text-muted">
                2 days ago
              </div>
            </div>
          </div>
    



        </div>

          
        <!-- Grid row -->

      </div>
      <!--Panel 2-->
      <!--Panel 3-->
      <div class="tab-pane fade" id="panel33" role="tabpanel">
        <div class="container my-5"> 
        <!-- Grid row -->
                <div class="row">
                  <h1>livestock hospital</h1>
                </div>
        </div>
        <!-- Grid row -->

      </div>
      <!--Panel 3-->

    </div>
    <!--Tab panels-->

  </section>
  <!-- Section -->

</div>